import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { toolbarStyles } from '../styles';
import { ChromePicker } from 'react-color';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import { DialogActions } from '@material-ui/core';

function ColorPicker(props) {

    const { classes, control, onToggle,handleFocus, color } = props;

    const [anchorEl, setAnchorEl] = useState(null)
    const [hex, setHex] = useState(color || '#000000')

    const handleClick = ({ currentTarget }) => setAnchorEl(currentTarget);

    const handleOk = () => {
        setAnchorEl(null);
        onToggle(control.value, hex);
    };

    const handleCancel = () => {
        setAnchorEl(null);
        handleFocus();
    };

    const handleChange = (color) => setHex(color.hex);

    const open = Boolean(anchorEl);

    return (
        <>
            <IconButton
                disableRipple
                className={classes.root}
                onClick={handleClick}
            >
                <control.icon />
                <ArrowDropDown />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <ChromePicker
                    disableAlpha
                    onChangeComplete={handleChange}
                    color={hex || color}
                />
                <DialogActions className={classes.actions}>
                    <Button onClick={handleCancel}>
                        cancel
                    </Button>
                    <Button color="primary" onClick={handleOk}>
                        ok
                    </Button>
                </DialogActions>
            </Popover>
        </>
    )
}

export default withStyles(toolbarStyles)(ColorPicker);
